export enum SpecialPricingOrderType {
    custom = 1,
    supply = 2
}
  